import { BATCH_MAX } from '../../constants/apiPaths';
import Button from '../../ui/Button';
import ButtonNew from '../../ui/ButtonNew';
import Loader from '../../ui/Loader';

function TokenApprovalModal({ close, onSubmittingRequest, processing, numberOfWinners }) {
    const numberOfBatches = Math.ceil(numberOfWinners / BATCH_MAX);
    console.log(numberOfBatches, 'numberOfBatches', numberOfWinners, BATCH_MAX);
    const handleOkayClick = () => {
        onSubmittingRequest(close);
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            close();
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"
            onClick={handleBackdropClick}
        >
            <div className="bg-grayBgNormal rounded-lg py-5 px-6 w-[36.125rem] mx-4">
                <h2 className="text-2xl font-semibold text-textPrimary border-b border-borderUnderline pb-5">Token Approval and Transfer</h2>

                <div className="mb-6 mt-5">
                    <p className="text-textPrimary ">
                        You'll be asked to approve <span className="font-semibold">{numberOfBatches + 1} transactions</span> to complete your payout:
                    </p>

                    <div className="">
                        <div>
                            <p className="text-textPrimary"> <span className='font-bold' >1 Token Approval Transaction</span> - Allows Impact Foundry to access your tokens for this payout. </p>

                        </div>

                        <div>
                            <p className="text-textPrimary"> <span className='font-bold' >{numberOfBatches} Token Transfer {numberOfBatches > 1 ? "Transactions" : "Transaction"}</span> - Sends the payout to the selected recipients.</p>
                        </div>
                    </div>

                    <p className=" text-textPrimary mt-2">
                        Both steps are required. Please confirm each transaction in your wallet when prompted.
                    </p>
                </div>

                <div className="flex justify-start">
                    <ButtonNew
                        onClick={handleOkayClick}
                        fixedMinWidth={true}
                        variant='blue'
                        size='sm'
                        disabled={processing}
                    >
                        {processing ? <Loader /> : 'Okay'}
                    </ButtonNew>
                </div>
            </div>
        </div>
    );
}

export default TokenApprovalModal;
